// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"281":"SecondBonusRoundRoute","514":"ThirdBonusRoundRoute","586":"FirstBonusRoundRoute"}[chunkId] || chunkId) + "." + {"281":"a83c79f3","514":"6fc55349","586":"4e987763","787":"8d4ce1b4"}[chunkId] + ".chunk.js";
};